module.exports = "/_next/static/images/ProcessingGDPRSuppression-3dea08fdd0a6f2d70c00cfa7637f5808.webp";